module.exports = __webpack_public_path__ + "media/landing_page/landing_page_bg-min-3-2c30ac0f.jpg";